import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table, } from 'antd';

import { uniqueId } from '../../../../../../../data/config/utils';
import ListTag from '../../../../../../../components/listtag';
import EditablePageHeader from '../../../../../../pagecontainer/components/editablepageheader';
import AddInputItem from '../../../../../../../components/form/addinputItem';
import TableCellAction from '../../../../../components/tablecellaction';
import ModalFooter from '../../../../../../../components/modalfooter';

class ListEntity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            new_normalised_value: null,
        };
        this.entitySubListTableColumns = [
            {
                title: "Normalized Value",
                key: "canonicalForm",
                dataIndex: "canonicalForm",
            },
            {
                title: "Synonyms",
                key: "list",
                dataIndex: "list",
                align: "center",
                render: (list, record, index) => {
                    return (
                        <ListTag key={index} list={list} placeholder="Type a synonym" deleteTag={(tag_index) => { const path = `active_entity_data.entity.subLists.${index}.list.${tag_index}`; this.props.actions.deleteEntityState(path); }} addNewTag={(tag) => this.addNewTag(tag, index)} default_input />
                    )
                }
            },
            {
                key: "clickAction",
                dataIndex: "clickAction",
                align: "right",
                render: (text, record, index) => {
                    return (
                        <TableCellAction align_right show_delete delete_popconfirm_title="Are you sure delete this item?" handleDeleteClick={() => { const path = `active_entity_data.entity.subLists.${index}`; this.props.actions.deleteEntityState(path); }} />
                    );
                }
            },
        ];
    }

    addNewTag = (tag, index) => {
        const { entity_details, actions } = this.props;
        if (entity_details.active_entity_data.entity.subLists && entity_details.active_entity_data.entity.subLists[index].list) {
            const path = `active_entity_data.entity.subLists.${index}.list.${entity_details.active_entity_data.entity.subLists[index].list.length}`;
            actions.updateEntityState(tag, path);
        } else {
            const path = `active_entity_data.entity.subLists.${index}.list`;
            actions.updateEntityState([tag], path);
        }
    };

    onChangeNewNormalisedValue = e => {
        this.setState({ new_normalised_value: e.target.value });
    };

    addNormalisedValue = () => {
        const { actions, entity_details } = this.props;
        const { new_normalised_value } = this.state;
        if (new_normalised_value && new_normalised_value.trim().length > 0) {
            const new_child = { canonicalForm: new_normalised_value.trim(), list: [] };
            const payload = entity_details.active_entity_data.entity.subLists ? [new_child, ...entity_details.active_entity_data.entity.subLists] : [new_child];
            actions.updateEntityState(payload, 'active_entity_data.entity.subLists');
            this.setState({ new_normalised_value: null });
        }
    };

    onKeyDownNormalisedValue = e => {
        if(e.keyCode === 13){
            this.addNormalisedValue();
        }
    };

    render() {
        const { page_details, entity_details, actions, goToEntitiesPage, updateEntity } = this.props;
        const { new_normalised_value } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        return (
            <Row>
                <EditablePageHeader btn_loading={entity_details.loaders.entity_updating} btn_text={entity_details.loaders.entity_updating ? 'Saving' : 'Save'} title={entity_details.active_entity_data.entity.name} onChangeTitle={(e) => actions.updateEntityState(e.target.value, 'active_entity_data.entity.name')} onClickBtn={updateEntity} onClickFirstBtn={goToEntitiesPage} editable show_btn show_first_btn />
                <Col xs={24} sm={{ span: 18, offset: 3 }} md={{ span: 16, offset: 4 }}>
                    <AddInputItem size="large" container_class="ori-t-pad-10" placeholder="Add new normalized value" show_add_btn={new_normalised_value && new_normalised_value.trim().length > 0} value={new_normalised_value} onChange={this.onChangeNewNormalisedValue} onKeyDown={this.onKeyDownNormalisedValue} onClickBtn={this.addNormalisedValue} />
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.entitySubListTableColumns} dataSource={entity_details.active_entity_data.entity.subLists} />
                </Col>
                <Col xs={24} className="ori-t-pad-10">
                    <ModalFooter button_ok_text={entity_details.loaders.entity_updating ? 'Saving' : 'Save'} loading={entity_details.loaders.entity_updating} handleOkClick={updateEntity} handleCancelClick={goToEntitiesPage} capsule_button />
                </Col>
            </Row>
        );
    }
}

ListEntity.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    entity_details: PropTypes.object,
    match: PropTypes.object,
    goToEntitiesPage: PropTypes.func,
    updateEntity: PropTypes.func,
};

export default ListEntity;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/entities/editentity/listentity/index.js